import { posthog } from '@/instrumentation-client';

import { flattenPostHogProperties } from './flatten';

import type { AnalyticsPlugin } from '../types';

const ensureOptedIn = () => {
  if (posthog.has_opted_out_capturing()) {
    posthog.opt_in_capturing({ captureEventName: false });
  }
};

export const createPostHogPlugin = (): AnalyticsPlugin => ({
  name: 'posthog',

  track: (event, context) => {
    switch (event.type) {
      case 'custom': {
        const properties = event.eventData
          ? flattenPostHogProperties(event.eventData)
          : {};

        ensureOptedIn();
        posthog.capture(event.eventName, {
          tenant_id: context.tenantId,
          site_id: context.siteId,
          session_id: context.sessionId,
          ...properties,
        });
        return;
      }
    }
  },

  identify: (event, context) => {
    const traits = event.traits ? flattenPostHogProperties(event.traits) : {};

    ensureOptedIn();
    posthog.identify(event.id, {
      tenant_id: context.tenantId,
      site_id: context.siteId,
      ...traits,
    });
  },

  page: (event, context) => {
    const properties = event.properties
      ? flattenPostHogProperties(event.properties)
      : {};

    ensureOptedIn();
    posthog.capture('$pageview', {
      tenant_id: context.tenantId,
      site_id: context.siteId,
      session_id: context.sessionId,
      page_name: event.name,
      ...properties,
    });
  },

  reset: () => {
    posthog.reset();
  },

  registerContext: properties => {
    posthog.register(flattenPostHogProperties(properties));
  },

  setGroup: group => {
    const properties = group.properties
      ? flattenPostHogProperties(group.properties)
      : {};

    posthog.group(group.type, group.id, properties);
  },
});
